import React, { useState } from "react";
import { AuthServices } from "../services/AuthServices";
import logo from "../../../assets/IMGS/shophrLogo.PNG";
import "../../../styles/login.css";
import { useNavigate } from "react-router-dom";

const CreateAccountForm = ({ handleAlreadyPartner }) => {
  const [formData, setFormData] = useState({});
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await AuthServices.createAccount(formData);
      if (response.status === 400) {
        setErrorMessage(response.message);
      }
      if (!response.success) {
        setLoading(false);
        setErrorMessage("This account already exists. Please try logging in.");
        setTimeout(() => {
          setErrorMessage("");
        }, 3000);
        return;
      }

      setLoading(false);
      setErrorMessage(
        "Please verify your email address. A link has been sent to your email."
      );
      localStorage.setItem("data", JSON.stringify(formData));
      localStorage.setItem("type", JSON.stringify("signup"));
      setTimeout(() => {
        navigate("/verification");
      }, 2000);
    } catch (error) {
      console.error(error);
      setErrorMessage(error?.response?.data?.message || "An error occurred");
      setLoading(false);
    }
  };

  return (
    <div className="form-container">
      <form onSubmit={handleSubmit}>
        <img src={logo} alt="logo" />
        <h2>Create an account!</h2>
        <div className="login-credentials">
          <label htmlFor="businessName">Business Name</label>
          <input
            placeholder="Enter your store name"
            onChange={handleChange}
            required
            autoComplete="name"
            type="text"
            name="businessName"
            id="businessName"
          />
        </div>
        <div className="login-credentials">
          <label htmlFor="businessEmail">Business Email</label>
          <input
            placeholder="Enter your business email"
            onChange={handleChange}
            required
            autoComplete="username"
            type="email"
            name="businessEmail"
            id="businessEmail"
          />
        </div>

        {errorMessage && (
          <div className="error-message">
            <p>{errorMessage}</p>
          </div>
        )}
        <button disabled={loading}>
          {loading ? "Loading..." : "Get Started"}
        </button>
        <button>Sign Up With Google</button>
        <p className="already-a-partner" onClick={handleAlreadyPartner}>
          Already have an account? <span>Log in</span>
        </p>
      </form>
    </div>
  );
};

export default CreateAccountForm;
